import React, { FC } from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';
import { Box } from '@mui/material';

import Button, { ButtonProps } from '../Button/Button';
import { cn } from '../lib/utils';
import Typography from '../Typography/Typography';

type EmptyStateProps = {
  dataTestId?: string;
  title?: string;
  description: React.ReactNode;
  buttonText?: string;
  hideButton?: boolean;
  icon?: string;
  className?: string;
  onClick?: () => void;
  extraButtons?: ButtonProps[];
  maxHeight?: string;
};

const EmptyState: FC<EmptyStateProps> = ({
  dataTestId,
  title,
  description,
  buttonText,
  className,
  onClick,
  extraButtons,
  hideButton = false,
  icon = 'fa-regular fa-cube',
  maxHeight,
}) => {
  if (!title && !description) return null;

  return (
    <div
      className={cn(
        'w-full max-w-[780px] bg-base-card  border border-base-border px-32 py-24 rounded-xl text-center mx-auto relative',
        className,
        maxHeight && `max-h-[${maxHeight}]`
      )}
      data-testid={dataTestId}
    >
      <Box className="flex flex-row gap-2 absolute top-2 right-2">
        {extraButtons?.map((button, index) => (
          <Button key={index} {...button} />
        ))}
      </Box>
      <div className={cn('flex items-center justify-center flex-col gap-2.5')}>
        <div className="p-4 rounded-md bg-base-muted">
          <FontAwesomeIcon
            icon={icon}
            className="text-base-mutedForeground h-5 w-5 text-p-l"
          />
        </div>
        <Typography className={cn('text-p-xl text-base-cardForeground')}>
          {title}
        </Typography>
        <Typography className={cn('text-p-s text-base-cardForeground')}>
          {description}
        </Typography>
      </div>
      {!hideButton && <Button isCreateButton className={cn('mt-6')} onClick={onClick}>
        {buttonText}
      </Button>}
    </div>
  );
};

export default EmptyState;
